export const RECAPTCHA_PUBLIC_KEY = "6LdpzdIqAAAAAM5iFLvfd-4Wmc8PJlHIOceCWSgg";
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";
// Debug configuration
export const DEBUG = import.meta.env.DEV || import.meta.env.VITE_DEBUG === 'true';
const DEV_HOST = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const SITE_ORIGIN = typeof window !== 'undefined' ? window.location.origin : 'https://www.thatshirtshow.com';

// Domain configuration
export const BASE_DOMAIN = DEBUG ? 'localhost' : '.thatshirtshow.com';
export const DOMAIN = DEBUG ? DEV_HOST : 'www.thatshirtshow.com';
export const BASE_URL = DEBUG ? `http://${DEV_HOST}:8000` : SITE_ORIGIN;
